import qs from 'qs';

export function toQueryUrl(obj) {
  return qs.stringify(obj);
  // return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
}

export function getQueryParamsFromLocation(location) {
  return qs.parse(location.search.substr(1));
}